import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 800px;
	margin-right: 30px;
	margin-top: 50px;
	scroll-margin-top: 200px;
	@media screen and (max-width: 900px) {
		width: 100%;
		margin-right: 0;
	}
`;
